module.exports = __webpack_public_path__ + "img/mediumrisk.85cf41af.png";